const configurationFields = vm => [
  {
    key: 'contactName',
    class: 'table__cell-contact-name',
    sortable: false,
    label: vm.$t('sensors.configuration-dm2.contact'),
    thStyle: {
      display: 'none',
    },
  },
  {
    key: 'description',
    class: 'table__cell-description',
    sortable: false,
    label: vm.$t('sensors.configuration-dm2.description'),
    thStyle: {
      display: 'none',
    },
  },
  {
    key: 'activeContact',
    class: 'table__cell-active-contact',
    sortable: false,
    label: vm.$t('sensors.configuration-dm2.active-contact'),
    thStyle: {
      display: 'none',
    },
  },
  {
    key: 'measurementUnit',
    class: 'table__cell-measuring-unit',
    sortable: false,
    label: vm.$t('sensors.configuration-dm2.measuring-unit'),
    thStyle: {
      display: 'none',
    },
  },
  {
    key: 'minCurrent',
    class: 'table__cell-min-current',
    sortable: false,
    label: vm.$t('sensors.configuration-dm2.min'),
  },
  {
    key: 'maxCurrent',
    class: 'table__cell-max-current',
    sortable: false,
    label: vm.$t('sensors.configuration-dm2.max'),
  },
  {
    key: 'minRange',
    class: 'table__cell-min-range',
    sortable: false,
    label: vm.$t('sensors.configuration-dm2.min'),
  },
  {
    key: 'maxRange',
    class: 'table__cell-max-range',
    sortable: false,
    label: vm.$t('sensors.configuration-dm2.max'),
  },
  {
    key: 'activateAlarm',
    class: 'table__cell-active-alarm',
    sortable: false,
    label: vm.$t('sensors.configuration-dm2.activate-alarm'),
    thStyle: {
      display: 'none',
    },
  },
];

export default configurationFields;
